
export default function portfolioFull() {
    const portfolios = document.querySelectorAll('.tz-portfolio-full');
    portfolios.forEach( portfolio => {
        const items = portfolio.querySelectorAll('.tz-portfolio-item');
        const bgContainer = portfolio.querySelector('.portfolio-bg');

        let itemTween;
        items.forEach(item => {
            const imageUrl = item.dataset.image;
            let currentImage = null;
            item.addEventListener('mouseenter', () => {
                const img = document.createElement('img');
                img.classList.add('fade');
                img.src = imageUrl;
                bgContainer.appendChild(img);
                img.style.opacity = 0;
                img.style.transform = 'scale(1.2)';
                bgContainer.appendChild(img);

                itemTween = gsap.to(img, {
                    opacity: 1,
                    scale: 1.1,
                    duration: 0.4,
                    ease: ' Linear.ease'
                });
                currentImage = img;
            });
            item.addEventListener('mouseleave', () => {
                const images = bgContainer.querySelectorAll('img');
                if (images.length > 1) {
                    const lastImage = images[images.length - 1];
                    gsap.to(lastImage, {
                        opacity: 0, scale: 1, duration: 0.4, ease: ' Linear.ease', onComplete: () => {
                            bgContainer.removeChild(lastImage);
                        }
                    });
                }
            });
        });
    } );
}